import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useCurrentUserStore } from "@src/state/currentUserState";

export default function RequiresTermsContainer(): React.JSX.Element {
  const { distributorConnections } = useCurrentUserStore();
  const needsUpdate = distributorConnections?.some(
    (c) => c.needsTermsUpdate === true,
  );

  if (needsUpdate) {
    return <Navigate to="/terms-update" replace />;
  }

  return <Outlet />;
}
